import { renderFxPaymentMethodOnChangePopup } from 'components/Discount/func';
import useFxFormAddTransactionStore from 'hooks/fx/useFxFormAddTransactionStore';
import { useDetectDevice } from 'hooks/useDetectDevice';
import useLang from 'hooks/useLang';
import { isEmpty } from 'lodash';
import React, { useEffect, useRef, useState } from 'react';

const withDetectPaymentMethodOnChange = (Component) => {
  const DetectPaymentMethodOnChangeComponent = (props) => {
    const {
      initialFormField,
      information,
      setInformation,
      validation,
      setValidation,
      informationChangeBackup,
      setInformationChangeBackup,
    } = props || {};

    const [
      isOpenFxPaymentMethodOnChangePopup,
      setOpenFxPaymentMethodOnChangePopup,
    ] = useState(false);

    const { t } = useLang();
    const { isDesktop } = useDetectDevice();

    const paymentMethodCache = useRef();

    const { paymentMethodName, addTransactionInformation, setPaymentMethod } =
      useFxFormAddTransactionStore();
    const { paymentMethod: paymentStore } = addTransactionInformation || {};

    useEffect(() => {
      if (isEmpty(paymentMethodName)) return;
      if (!paymentMethodCache.current) {
        paymentMethodCache.current = paymentMethodName;
      }
    }, [paymentMethodName, paymentMethodCache]);

    const handleOnClickFxPaymentMethodOnChangePopup = () => {
      if (informationChangeBackup) {
        setInformation(informationChangeBackup);

        const newPaymentMethod = {
          ...paymentStore,
          ...informationChangeBackup,
          discountsAvailable: [],
          discountApplied: null,
        };
        setPaymentMethod(newPaymentMethod);

        setInformationChangeBackup(null);

        setValidation(initialFormField);
      }
    };
    const handleOnCloseFxPaymentMethodOnChangePopup = () => {
      setInformationChangeBackup(null);
    };

    const newProps = {
      ...props,
      setOpenFxPaymentMethodOnChangePopup,
      paymentMethodCache: paymentMethodCache?.current,
    };
    return (
      <>
        {isOpenFxPaymentMethodOnChangePopup &&
          renderFxPaymentMethodOnChangePopup({
            t,
            isOpen: isOpenFxPaymentMethodOnChangePopup,
            setOpen: setOpenFxPaymentMethodOnChangePopup,
            paymentMethod: paymentMethodName,
            onCloseExt: handleOnCloseFxPaymentMethodOnChangePopup,
            onClickExt: handleOnClickFxPaymentMethodOnChangePopup,
            contentReplace: t('form_fx_payment_method_change_desc'),
            isDesktop,
          })}
        <Component {...newProps} />
      </>
    );
  };
  return DetectPaymentMethodOnChangeComponent;
};

export default withDetectPaymentMethodOnChange;
